"use client"
import {signInSchema} from "../sign-in-schema";
import {PasswordField} from "@/components/form/PasswordField";
import {Form} from "@/components/form/Form";
import {TextField} from "@/components/form/TextField";
import {OnSubmit, ZodObjectType} from "@/components/form/utils";


interface LoginProps<S extends ZodObjectType> {
    loading?: boolean;
    handleEmailLogin: OnSubmit<S>
    cancelUrl?: string;
}

export function Login({
                          handleEmailLogin,
                          cancelUrl,
                      }: LoginProps<typeof signInSchema>) {

    return (
        <div className="space-y-6">
            <div className="text-center space-y-2">
                <h2 className="text-2xl font-bold">Login</h2>
                <p className="text-muted-foreground"></p>
            </div>
            {/* Social Login Options */}
            <Form
                onSubmit={handleEmailLogin}
                schema={signInSchema}
                className="space-y-4"
                submitText={'Login'}>
                <div className="grid grid-cols-1 gap-4">
                    <TextField name={'email'} label={'Email'}/>
                    <PasswordField name={'password'} label={'Password'}/>
                </div>
            </Form>
            <div className="text-center text-sm text-muted-foreground">
                Don&#39;t have an account? <a href="/account-request" className="text-primary hover:underline">Register</a>
            </div>
            <div className="text-center text-sm text-muted-foreground">
                <a href="/forgot-password" className="text-primary hover:underline">Forgot Password?</a>
            </div>
            {cancelUrl && (
                <div className="text-center">
                    <a
                        href={cancelUrl}
                        className="text-sm text-muted-foreground hover:underline"
                    >
                        Cancel and return to checkout
                    </a>
                </div>
            )}
        </div>
    )
}

